import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { HomeHeroAdCard } from "./HomeHeroAdCard";
import { CreatorSpotlightCard } from "./CreatorSpotlightCard";
import {
  fetchActiveHomeHeroAds,
  type ActiveHomeHeroAd,
} from "../lib/homeHeroAd";

export function HomeHero({ teacherCount }: { teacherCount: number | null }) {
  const [heroAd, setHeroAd] = useState<ActiveHomeHeroAd | null>(null);
  const [thirdAd, setThirdAd] = useState<ActiveHomeHeroAd | null>(null);
  const [wideAd, setWideAd] = useState<ActiveHomeHeroAd | null>(null);
  const [adsReady, setAdsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void fetchActiveHomeHeroAds().then((next) => {
      if (cancelled) return;
      setHeroAd(next.hero);
      setWideAd(next.wide);
      setThirdAd(next.third);
      setAdsReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="fe-home-hero">
      <div className="fe-hero-copy">
        <div className="fe-eyebrow">
          <span className="fe-status-dot" /> FOR TEACHERS, WITH CARE
        </div>
        <h1>
          선생님의 하루에,
          <br />
          <span>조금 더 여유를.</span>
        </h1>
        <p>
          반복되는 업무는 가볍게, 아이들과의 시간은 깊게.
          <br className="hidden sm:block" /> 수업부터 학급 운영까지, 선생님 곁의
          작은 동료.
        </p>
        <div className="fe-hero-actions">
          <Link to="/workmate" className="fe-button fe-button-dark">
            나에게 필요한 도구 찾기 <ArrowUpRight size={19} />
          </Link>
          <Link to="/guide" className="fe-text-link">
            처음 오셨나요? <ArrowUpRight size={16} />
          </Link>
        </div>
        <div className="fe-hero-community">
          <span className="fe-avatar-stack" aria-hidden="true">
            <span>김</span>
            <span>이</span>
            <span>박</span>
            <span>최</span>
          </span>
          <span>
            {teacherCount !== null ? (
              <>
                <strong>{teacherCount.toLocaleString("ko-KR")}명</strong>의
                선생님과 함께해요
              </>
            ) : (
              <>선생님을 위해, 선생님이 만들어요</>
            )}
          </span>
        </div>
      </div>
      <div className="fe-hero-promotions" role="region" aria-label="홈 광고와 교사 크리에이터 소개" aria-busy={!adsReady} tabIndex={0}>
        {wideAd ? <HomeHeroAdCard key={wideAd.updatedAt} ad={wideAd} /> : null}
        {heroAd ? <HomeHeroAdCard key={heroAd.updatedAt} ad={heroAd} /> : null}
        {/* Mount all cards together so mobile scroll snapping starts at the first ad. */}
        {thirdAd ? <HomeHeroAdCard key={thirdAd.updatedAt} ad={thirdAd} /> : adsReady ? <CreatorSpotlightCard /> : null}
      </div>
    </section>
  );
}
